/**
 * Sticky header scroll-state.
 *
 * Toggles `.is-scrolled` on `.c-site-header` once the page scrolls past a small
 * threshold — the navy glass scrim (_site-header.css) fades in. A rAF-throttled
 * passive scroll listener: jank-free, and simpler/more robust than a sentinel
 * IntersectionObserver. NECO's first component JS — the module pattern other
 * blocks follow as they need behaviour. Degrades to a permanently transparent
 * header when JS is off (never broken).
 */

const header = document.querySelector( '.c-site-header' );

if ( header ) {
	let ticking = false;

	const update = () => {
		header.classList.toggle( 'is-scrolled', window.scrollY > 20 );
		ticking = false;
	};

	window.addEventListener(
		'scroll',
		() => {
			if ( ! ticking ) {
				window.requestAnimationFrame( update );
				ticking = true;
			}
		},
		{ passive: true }
	);

	update(); // set initial state (e.g. on a reload mid-page)
}
